import React from 'react';
import { Link } from 'react-router-dom';

import Footer from './shared/Footer';

const getInternalIconStyle = () => {
	return process.env.DOCS_TYPE === 'internal' && ' fa-spin ';
};

const Home = () => (
	<div className="page">
		<div className="content" id="content">
			<div className="section">
				<h1>Build the communications community that’s right for you.</h1>
				<p>Customize the design and capabilities of your community by leveraging the Dynamic Signal APIs to match your individual needs.</p>

				<div className="panels">

					<div className="panel">
						<i className={`fa fa-puzzle-piece ${getInternalIconStyle()}`}></i>
						<div>
							<h2>Getting Started</h2>
							<div>
								Discover how the Dynamic Signal developer program works and how to leverage the platform to create your community.
							</div>
							<Link to="/getting-started" className="button">Learn More</Link>
						</div>
					</div>

					<div className="panel">
						<i className={`fa fa-cogs ${getInternalIconStyle()}`}></i>
						<div>
							<h2>API Reference</h2>
							<div>
								Review the API technical reference to help you integrate with the Dynamic Signal platform.
							</div>
							<Link to="/api" className="button">Learn More</Link>
						</div>
					</div>

					{process.env.DOCS_TYPE === 'internal' &&
						<div className="panel">
							<i className={`fa fa-code ${getInternalIconStyle()}`}></i>
							<div>
								<h2>JavaScript SDK</h2>
								<div>
									Learn to use our JavaScript SDK to easily enable platform functionality across your own sites.
								</div>
								<Link to="/javascript-sdk" className="button">Learn More</Link>
							</div>
						</div>
					}

					{process.env.DOCS_TYPE === 'internal' &&
						<div className="panel">
							<i className={`fa fa-photo ${getInternalIconStyle()}`}></i>
							<div>
								<h2>Widget Reference</h2>
								<div>
									Learn to use our reusable widgets that can help you quickly build a website showing you community content.
								</div>
								<Link to="/widgets" className="button">Learn More</Link>
							</div>
						</div>
					}

				</div>
			</div>
			<Footer />
		</div>
	</div>
);

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js